import { Controller } from "@hotwired/stimulus";

// Auto-submits the form it is attached to whenever a field changes, and keeps
// an optional radius readout in sync. Used by the Locals professionals/map
// filter bar so selecting a discipline/city or moving the radius slider
// re-queries without an explicit "Apply" click (the button stays as a
// no-JS fallback).
export default class extends Controller {
  static targets = ["radius", "radiusOutput"];

  submit() {
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }

  updateRadius() {
    if (this.hasRadiusTarget && this.hasRadiusOutputTarget) {
      this.radiusOutputTarget.textContent = `${this.radiusTarget.value} km`;
    }
  }
}
